import {CapabilitiesSection} from '@/components/landing/CapabilitiesSection';
import {DeveloperSection} from '@/components/landing/DeveloperSection';
import {DocumentationSection} from '@/components/landing/DocumentationSection';
import {FinalCTA} from '@/components/landing/FinalCTA';
import {Footer} from '@/components/landing/Footer';
import {HeroSection} from '@/components/landing/HeroSection';
import {SocialProofSection} from '@/components/landing/SocialProofSection';
import {Navbar} from '@/components/landing/Navbar';
import {OperationFlowSection} from '@/components/landing/OperationFlowSection';
import {SecuritySection} from '@/components/landing/SecuritySection';
import {TransactionContextSection} from '@/components/landing/TransactionContextSection';
import {UsageModesSection} from '@/components/landing/UsageModesSection';
import {UseCasesSection} from '@/components/landing/UseCasesSection';
import {WhatsAppButton} from '@/components/landing/WhatsAppButton';

export default function KobraLanding() {
  return (
    <div className="min-h-screen bg-kobra-bg text-kobra-text-dark font-sans selection:bg-kobra-accent selection:text-white">
      <Navbar />
      <main>
        <HeroSection />
        <SocialProofSection />
        <UsageModesSection />
        <CapabilitiesSection />
        <TransactionContextSection />
        <OperationFlowSection />
        <UseCasesSection />
        <DeveloperSection />
        <SecuritySection />
        <DocumentationSection />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
